import {
  installerDifferencesReducer,
  installerTestsReducer
} from '../reducers';
import {
  subscriptionTypes,
  signalRHubManager
} from './signalRHub/signalRHubManager';
import {
  api,
  apiActionDispatcher,
  apiCall,
  signalRWrappedApiCall
} from './api';
import * as types from './types';
import { difference } from 'lodash';

const fetchInstallerTestExpectedDispatcher =
  apiActionDispatcher({
    actionTypes: types.fetchInstallerTestExpectedActionTypes,
    responseHandler: (response) => {
      const expected = {};
      for (const entry of response) {
        if (!entry) continue;
        const key = entry.filename + '_' + entry.presence;
        expected[key] = {
          'Expected': entry.expected,
          'Presence': entry.presencePrettyName,
          'PresenceId': entry.presenceId,
          'Runners': entry.runners && entry.runners.split(','),
          'Username': entry.username
        };
      }
      return expected;
    },
    emptyResult: () => 0
  });

// ! Latest results will always overwrite previously fetched
// Due to the nature of the response, there may not be a quick way
// to convert this to a multiIdApiCall (which would be ideal)
export const fetchInstallerExpectedFiles = (jobIds) => {
  return signalRWrappedApiCall(
    apiCall(
      fetchInstallerTestExpectedDispatcher,
      api.installerFiles.fetchInstallerTestExpected,
      false,
      null,
      (state) => {
        // ! this is cheating how this cacheRequest really should work
        // this logic cheats it to work like hasBeenLoaded which can't be used here
        //
        // if same set of jobIds then ignore
        const previousCache =
          installerTestsReducer.getinstallerTestExpectedState(state).request;
        const previousArgs = previousCache.args || [];
        const isDifferent = difference(jobIds, previousArgs).length > 0;
        const resultCache = {
          args: jobIds,
          inProgress: !isDifferent
        };
        return resultCache;
      },
      jobIds
    ),
    fetchInstallerTestExpectedDispatcher([]),
    signalRHubManager,
    subscriptionTypes.installerTestExpected,
    state => Object.keys(installerTestsReducer.getinstallerTestExpected(state))
  );
};

const fetchInstallerDifferencesDispatcher = (buildId, baselineBuildId, product) =>
  apiActionDispatcher({
    actionTypes: types.fetchInstallerDifferencesActionTypes,
    responseHandler: response => response.reduce((result, file) => {
      result[file.id] = {
        ...file,
        buildId,
        baselineBuildId,
        product,
        selected: false
      };
      return result;
    }, {})
  });
export const fetchInstallerDifferences = (buildId, baselineBuildId, product) => apiCall(
  fetchInstallerDifferencesDispatcher(buildId, baselineBuildId, product),
  api.installerFiles.fetchDifferences,
  state => installerDifferencesReducer
    .getInstallerDifferenceByBuildsIds(state, buildId, baselineBuildId),
  null,
  state => {
    const cachedRequestArgs = state.installerDifferences.request.args;
    return {
      inProgress: cachedRequestArgs &&
        cachedRequestArgs[buildId] &&
        cachedRequestArgs[buildId]
          .find(id => id === baselineBuildId) !== undefined,
      args: [buildId, baselineBuildId, product]
    };
  },
  [buildId, baselineBuildId, product]
);

const setInstallerExpectedFileDispatcher =
  apiActionDispatcher({
    actionTypes: types.setInstallerTestExpectedActionTypes,
    responseHandler: null
  });

export const setInstallerExpectedFile = (filename, presenceId, expected, username) =>
  apiCall(
    setInstallerExpectedFileDispatcher,
    api.installerFiles.installerSetWhiteTestExpected,
    null,
    null,
    null,
    [filename, presenceId, expected, username]
  );

export const CHANGE_INSTALLER_FILE = 'CHANGE_INSTALLER_FILE';
export const changeInstallerFile = (file) => (dispatch, getState) => {
  const currentFile = installerDifferencesReducer.getFileById(getState(), file.id);
  if (currentFile && currentFile.expected !== file.expected) {
    api.installerFiles.setExpected(file.expected, [file.id]);
  }

  dispatch({
    type: CHANGE_INSTALLER_FILE,
    file
  });
};

export const SELECT_ALL_INSTALLER_FILES = 'SELECT_ALL_INSTALLER_FILES';
export const selectAllInstallerFiles = (files, selected) => ({
  type: SELECT_ALL_INSTALLER_FILES,
  selected,
  files
});

export const SET_SELECTED_INSTALLER_FILES_AS_EXPECTED =
  'SET_SELECTED_INSTALLER_FILES_AS_EXPECTED';
export const setSelectedInstallerFilesAsExpected = (files, expected, isJiraRequest) =>
  (dispatch) => {
    const selectedFiles = files.filter(f => f.selected);
    if (!isJiraRequest) {
      api.installerFiles.setExpected(expected, selectedFiles.map(f => f.id));
    }

    dispatch({
      type: SET_SELECTED_INSTALLER_FILES_AS_EXPECTED,
      expected,
      files: selectedFiles
    });
  };

export const SET_INSTALLER_EXPANDED = 'SET_INSTALLER_EXPANDED';
export const setInstallerExpanded = (expanded) => ({
  type: SET_INSTALLER_EXPANDED,
  expanded
});



// WEBPACK FOOTER //
// src/actions/installerFiles.js